module.exports = __webpack_public_path__ + "static/property-2-3a9e13665cf33bc6b612ab287cb78c69.jpg";